import { ViewHeader, Blocked } from '../ui'

/**
 * Policy is read-only and last, by agreement.
 *
 * There is no policies table, and a table alone would only produce a page
 * describing rules nobody enforces: the spec's own footnote ("an auto-cleared
 * item still gets a decision record -- it just records the rule as the decider
 * instead of a person") puts the evaluation in the dispatcher, deciding whether
 * to create an approval at all. That is fleet behaviour, not dashboard
 * behaviour, and this view only ever reads it.
 */
export function Policy() {
  return (
    <>
      <ViewHeader title="Policy" aside="What agents may do without asking" />
      <Blocked
        title="Everything queues. No autonomy rules are active."
        meta="Unblocked by: a policies table in sql/fleet/, and the dispatcher consulting it."
      >
        Nothing is delegated to an agent today, so every item a human owes a decision on reaches
        the inbox. When autonomy rules exist they will be evaluated by the dispatcher, and an
        auto-cleared item will still produce a decision record — recording the rule as the decider
        instead of a person. This view will list them; it will not be what enforces them, and the
        on/off and New rule controls in the design are writes this app has no grant for.
      </Blocked>
    </>
  )
}
